import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getContentHeaders, postContentHeaders} from '../common/headers';
import {AuthHttp} from 'angular2-jwt';
import {BaseService} from '../base/service.base';
import {Maintenance} from '../models/maintenance.model';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class MaintenanceService extends BaseService {
  private _maintenances$: BehaviorSubject<Maintenance[]>;
  private _dataStore: {
    maintenances: Maintenance[]
  };

  constructor(private _http: AuthHttp) {
    super();
    this._dataStore = {maintenances: []};
    this._maintenances$ = <BehaviorSubject<Maintenance[]>>new BehaviorSubject([]);
  }

  get maintenances$() {
    return this._maintenances$.asObservable();
  }

  public loadAll(filter: string = '') {
    this._http.get(`${this.baseApiUrl}/maintenances${filter}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.maintenances = result;
      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not load maintenances.'));
  }

  public load(id: any): Promise<any> {
    const promise: Promise<any[]> = new Promise((resolve, reject) => {
      this._http.get(`${this.baseApiUrl}/maintenances/${id}`, {headers: getContentHeaders})
        .map(response => response.json()).subscribe(result => {
        let notFound = true;

        this._dataStore.maintenances.forEach((item, index) => {
          if (item._id === result._id) {
            this._dataStore.maintenances[index] = result;
            notFound = false;
          }
        });

        if (notFound) {
          this._dataStore.maintenances.push(result);
        }

        this._maintenances$.next(this._dataStore.maintenances);
        resolve(result);
      }, error => {
          console.error('Could not load maintenance.');
          reject(error);
      });
    });

    return promise;
  }

  public create(maintenance: Maintenance): Observable<any> {
    const shareable = this._http.post(`${this.baseApiUrl}/maintenances`, JSON.stringify(maintenance),
      {headers: postContentHeaders}).map(response => response.json()).share()
    shareable.subscribe(result => {
      this._dataStore.maintenances.push(result);
      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not create maintenance.'));

    return shareable;
  }

  public sendMail(id: string): void {
    this._http.get(`${this.baseApiUrl}/maintenances/${id}/send`, {headers: getContentHeaders})
      .map(response => response.json());
  }

  public update(maintenance: Maintenance): Observable<any> {
    const shareable = this._http.put(`${this.baseApiUrl}/maintenances/${maintenance._id}`, JSON.stringify(maintenance), {headers: postContentHeaders})
      .map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.maintenances.forEach((defi, i) => {
        if (defi._id === result._id) {
          this._dataStore.maintenances[i] = result;
        }
      });

      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not update maintenance.'));

    return shareable;
  }

  public remove(maintenanceId: string) {
    this._http.delete(`${this.baseApiUrl}/maintenances/${maintenanceId}`).subscribe(response => {
      this._dataStore.maintenances.forEach((t, i) => {
        if (t._id === maintenanceId) {
          this._dataStore.maintenances.splice(i, 1);
        }
      });

      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not delete maintenance.'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/maintenance.service.ts